import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import MaterialTable from "material-table";
import TextField from "@material-ui/core/TextField";
import { Autocomplete } from "@mui/material";
import UiUtils from "../../../provider/UiUtils";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import store from "../../../redux/store";
import ApplicationStateAction from "../../../redux/applicationState/ApplicationStateAction";
import AdminMenuWithBreadScrum from "../adminMenu/AdminMenuWithBreadScrum";
import { ApMessageTemplate_Url } from "../../../provider/ServiceUrl";
import PtsButton from "../../givBee/buttons/PtsButton";
import Utils from "../../../provider/Utils";

class MessageTemplateList extends Component {
  header = store.getState().adminHeader.adminHeader;
  adminMsgTemplateState =
    store.getState().applicationState.adminMsgTemplateState;
  adminMsgTemplateStateDetails = {};
  title = "Message Template List";
  breadCrumb = [{ pageid: "", uiname: "Message Template List" }];
  constructor(props) {
    super(props);
    let businessDomain = null;
    if (props.state) {
      businessDomain = props.state.businessDomain;
    }
    if (this.adminMsgTemplateState) {
      this.adminMsgTemplateStateDetails = Object.getOwnPropertyNames(
        this.adminMsgTemplateState
      );
    }
    if (this.adminMsgTemplateStateDetails.length > 0) {
      this.state = {
        businessDomain: businessDomain,
        initialPage: this.adminMsgTemplateState.initialPage,
        pageSize: this.adminMsgTemplateState.pageSize,
        searchText: this.adminMsgTemplateState.searchText,
        businessDomainList: [],
        messageTemplateList: [],
        isPaging: false,
        render: false,
        getCreatePermission: false,
        smsTemplateId: this.adminMsgTemplateState.smsTemplateId,
      };
    } else {
      this.state = {
        searchText: "",
        initialPage: 0,
        pageSize: 20,
        messageTemplateList: [],
        businessDomainList: [],
        businessDomain: businessDomain,
        isPaging: false,
        render: false,
        getCreatePermission: false,
        smsTemplateId: "",
      };
    }
  }

  componentDidMount() {
    const postObject = {
      header: this.header,
    };

    AdminFetchServerData.callPostService(
      "/businessDomainms/getList",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let businessDomainList = output.data.businessDomainList;
        let businessDomain =
          this.state.businessDomain !== null
            ? this.state.businessDomain
            : Utils.getArrayElement(businessDomainList, 0);
        this.getBusinessTypeList(businessDomain);
        this.setState({
          businessDomainList: businessDomainList,
          businessDomain: businessDomain,
        });
      }
    });
  }

  handleBusinessDomainChange(selectedDomain) {
    this.getBusinessTypeList(selectedDomain);
    this.setState({
      businessDomain: selectedDomain,
    });
  }

  getBusinessTypeList(businessDomain) {
    const postObject = {
      header: this.header,
      businessDomainId: businessDomain?.id,
    };

    AdminFetchServerData.callPostService(
      "/msgTemplatems/getListForBusinessDomain",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let messageTemplateList = output.data.messageTemplateList;
        let getPermission = Utils.getRolePermission(output.data?.privilegeList);
        let getCreatePermission = getPermission[1];
        let isPaging = false;
        if (messageTemplateList.length > this.state.pageSize) {
          isPaging = true;
        }
        this.setState({
          render: true,
          isPaging: isPaging,
          initialPage: this.state.initialPage,
          messageTemplateList: messageTemplateList,
          getCreatePermission: getCreatePermission,
        });
      }
    });
  }

  async addMessageTemplate() {
    this.props.navigate("/smsTemplate", {
      state: {
        action: "create",
        businessDomain: this.state.businessDomain,
      },
    });
  }

  toMessageTempalteDetails(e, data) {
    let adminMsgTemplateState = {
      smsTemplateId: data.id,
      initialPage: this.state.initialPage,
      pageSize: this.state.pageSize,
      searchText: this.state.searchText,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ adminMsgTemplateState })
    );
    this.props.navigate("/smsTemplate", {
      state: {
        action: "view",
        smsTemplateId: data.id,
        businessDomain: this.state.businessDomain,
      },
    });
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ initialPage: page, pageSize: pageSize });
  }
  handleSearchChange(searchText) {
    let adminMsgTemplateState = {
      smsTemplateId: this.state.smsTemplateId,
      initialPage: this.state.initialPage,
      pageSize: this.state.pageSize,
      searchText: searchText,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ adminMsgTemplateState })
    );
    this.setState({ searchText: searchText });
  }
  render() {
    if (this.state.render === false) {
      return <div />;
    }
    return (
      <>
        <AdminMenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          history={this.props.history}
          name={this.title}
          isSearchText={this.state.searchText !== ""}
        />
        <div className="row mb-4 pt-0">
          <div className="col-md-8" id="assetFormLabel">
            <div className="row d-flex">
              <label
                className="col-md-2 MuiAutocomplete-label form-label align-self-center mb-0 text-end"
                htmlFor="collapsible-appUserRole"
              >
                Business Domain
              </label>
              <div className="col-md-4 autoCompleteList" id="assetFormLabel">
                <Autocomplete
                  id="size-small-outlined"
                  size="small"
                  fullWidth
                  disableClearable
                  autoComplete="off"
                  options={this.state.businessDomainList}
                  value={this.state.businessDomain}
                  getOptionLabel={(option) => option.name}
                  defaultValue={this.state.businessDomain}
                  onChange={(event, value) => {
                    this.handleBusinessDomainChange(value);
                  }}
                  inputprops={{
                    style: { textTransform: "capitalize" },
                  }}
                  renderOption={(props, option) => (
                    <li
                      {...props}
                      style={{
                        padding: "5px 15px",
                      }}
                    >
                      {option.name}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Please Select"
                      variant="outlined"
                      size="small"
                      className="autoComplete"
                      style={{ background: "#fff", top: "0px" }}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        </div>
        <div style={{ maxWidth: "100%" }}>
          <MaterialTable
            title=""
            onRowClick={(event, rowData) => {
              this.toMessageTempalteDetails(event, rowData);
              event.stopPropagation();
            }}
            icons={UiUtils.getMaterialTableIcons()}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h5 className="dataNotAvailable">No data found.</h5>
                ),
              },
            }}
            columns={[
              {
                title: "#",
                render: (rowData) => rowData.tableData.id + 1,
                width: "5%",
                align: "left",
                cellStyle: {
                  width: "6%",
                },
              },
              {
                title: "Message Title",
                field: "messageName",
                cellStyle: {
                  width: "20%",
                },
              },
              {
                title: "Keyword",
                field: "keyword",
                cellStyle: {
                  width: "20%",
                },
              },

              {
                title: "Business Type",
                field: "businessTypeName",
                cellStyle: {
                  width: "20%",
                },
              },
              {
                title: "Message Type",
                field: "messagetype",
                cellStyle: {
                  wordBreak: "break-word",
                  width: "20%",
                },
              },
            ]}
            data={this.state.messageTemplateList}
            options={{
              sorting: true,
              actionsColumnIndex: -1,
              searchText: this.state.searchText,
              initialPage: this.state.initialPage,
              pageSize: this.state.pageSize,
              pageSizeOptions: [5, 10, 20, 50, 100],
              paging: this.state.isPaging,
              headerStyle: {
                backgroundColor: "#37517e",
                fontWeight: "bold",
                color: "#ffff",
                align: "left",
              },
              rowStyle: (rowData) => ({
                backgroundColor:
                  rowData.id === this.state.smsTemplateId ? "#e6effc" : "",
                height: "3em",
                textTransform: "capitalize",
              }),
            }}
            onSearchChange={(searchText) => {
              this.handleSearchChange(searchText);
            }}
            onChangePage={(page, pageSize) => {
              this.handleMaterialTablePageChange(page, pageSize);
            }}
            actions={[
              {
                icon: () =>
                  this.state.getCreatePermission && (
                    <PtsButton btnName="Add Message Template" type="submit" />
                  ),
                isFreeAction: true,
                onClick: (event) => this.addMessageTemplate(),
              },
            ]}
          />
        </div>
      </>
    );
  }
}
export default withRouter(MessageTemplateList);
